<script>
  import { __ } from '../../utils/i18n';
  import RepAction from "./RepAction.svelte";
    /**
     * @type {string}
     */
    export let reps;
    export let  headers;

    // console.log(reps)
 
    const phoneNumber = (d) => {
    // removes anything that's not a digit from the phone number
    return String(d).replace(/\D/g, '');


  };

  // console.log('headers in reptable:', headers, 'reps:', reps);


  </script>
  <table class="reptable">
    {#each headers as header,i}
      <tr>
        <th colspan="2">
            { __(header) }
        </th>
      </tr>
    {#each reps[i] as r}
    <tr>
      <td class="col1">
        { __(r.office) }
      </td>
      <td class="col2">
        <div class="flex">
          <span>
            { __(r.repname) }
          </span>
          <span>
            <RepAction 
              phoneNumber={phoneNumber(r.phone)}
              emailAddress={r.email}
              website={r.site}
            />
          </span>
        </div>
      </td>
    </tr>
      {/each}
    {/each}
</table>

